import { helper } from '@ember/component/helper';

export function isNot(params /*, hash*/) {
  return !params[0];
}

export default helper(isNot);
